/** ABET's branded cold-start state, shared by data-heavy dashboard modules. */
export default function AbetChipLoader({ message = 'Loading...', size = 76 }) {
  const gold = 'var(--accent-secondary, #FDB515)'
  const face = {
    position: 'absolute', inset: 0, borderRadius: '50%', display: 'grid', placeItems: 'center',
    backfaceVisibility: 'hidden', border: `3px solid ${gold}`,
    background: 'radial-gradient(circle at 34% 30%, #1b2431 0%, #0d131c 62%, #070B0F 100%)',
    boxShadow: '0 0 24px rgba(253,181,21,0.28), inset 0 0 16px rgba(253,181,21,0.10)',
  }
  const alpha = {
    fontFamily: "'Times New Roman', serif", fontSize: Math.round(size * 0.52), fontWeight: 700,
    color: gold, textShadow: '0 0 18px rgba(253,181,21,0.5)', lineHeight: 0.88,
    transform: 'translateY(-2px)',
  }
  const notches = Array.from({ length: 8 }, (_, index) => (
    <span key={index} style={{
      position: 'absolute', left: '50%', top: 2, width: Math.max(6, Math.round(size * 0.09)),
      height: Math.max(8, Math.round(size * 0.12)), marginLeft: -Math.max(3, Math.round(size * 0.045)),
      borderRadius: 2, background: 'rgba(253,181,21,0.85)',
      transformOrigin: `50% ${size / 2 - 2}px`, transform: `rotate(${index * 45}deg)`,
    }} />
  ))

  return (
    <>
      <div className="abet-chip-loader" role="status" aria-live="polite">
        <div className="abet-chip-perspective" style={{ width: size, height: size }}>
          <div className="abet-chip-spinner">
            <div style={face}>{notches}<span style={alpha}>&alpha;</span></div>
            <div style={{ ...face, transform: 'rotateY(180deg)' }}>{notches}<span style={alpha}>&alpha;</span></div>
          </div>
        </div>
        <span>{message}</span>
      </div>
      <style>{`
        .abet-chip-loader { display:flex; flex-direction:column; align-items:center; gap:16px; padding:38px 0 }
        .abet-chip-loader > span { font-size:13px; letter-spacing:.04em; opacity:.75 }
        .abet-chip-perspective { perspective:620px }
        .abet-chip-spinner { position:relative; width:100%; height:100%; transform-style:preserve-3d;
          animation:abet-chip-flip 2.4s cubic-bezier(.45,.05,.35,1) infinite }
        @keyframes abet-chip-flip {
          0% { transform:rotateY(0deg) translateY(0) }
          45% { transform:rotateY(540deg) translateY(-10px) }
          70% { transform:rotateY(720deg) translateY(0) }
          78% { transform:rotateY(720deg) translateY(-3px) }
          86%,100% { transform:rotateY(720deg) translateY(0) }
        }
        @media (prefers-reduced-motion:reduce) { .abet-chip-spinner { animation:none } }
      `}</style>
    </>
  )
}
